<template>
	<div>
		<div v-if="typeof componentItem !== 'string'">
			<template v-for="(content, i) in componentItem">
				<div :key="`${i}`">

					<div v-if="typeof content !== 'object' && (i !== 'template') && (i !== 'description-twitter') && (i !== 'description')" >
						<div class="form-group">
							<label>{{ i }}</label>
							<input type="text" class="form-control" :id="i" v-model="componentItem[i]" >
						</div>
					</div>
					<div v-if="i === 'description-twitter'" >
						<div class="form-group">
							<label>{{ i }}</label>
							<textarea rows="3" class="form-control" :id="i" v-model="componentItem[i]" ></textarea>
						</div>
					</div>
					<div v-if="i === 'description'" >
						<div class="form-group">
							<label>{{ i }}</label>
							<textarea rows="3" class="form-control" :id="i" v-model="componentItem[i]" ></textarea>
						</div>
					</div>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
	export default {
		
		name: 'Social',
		
		props: ['componentItem', 'index'],

	}
</script>

<style lang="scss" scoped>
	@import '@/scss/style.scss';

	label {
		display: block
	}

	html {
		font-size: 16px;
	}

	.btn:not(:last-of-type) {
		margin-right: 15px;
	}
	
</style>